import Nav from "@/components/Header/Nav/Nav.tsx";
import Footer from "@/components/Footer/Footer.tsx";

import GridComponent from "@/components/GridComponent/GridComponent";
import OpenMenuBlock from "@/components/OpenMenuBlock/OpenMenuBlock";
import ServiceBlockBerlinGrid from "@/components/ServiceBlockBerlin/ServiceBlockBerlinGrid";
import type { Service } from "@/components/ServiceBlockBerlin/ServiceBlockBerlin";
import VideoContainer from "@/components/VideoContainer/VideoContainer";
import ImageContainer from "@/components/ImageContainer/ImageContainer";
import DoubleBlock from "@/components/DoubleBlock/DoubleBlock";
import { useEffect } from "react";
import CookiePopupButton from "../components/CookieBanner/CookiePopupButton";

const services: Service[] = [
  {
    id: "01",
    title: "Reparatur & Wartung",
    description:
      "Wir sind spezialisiert auf den Austausch von Mechatronik in DSG- und S-Tronic-Getrieben. Unsere Experten übernehmen die professionelle Demontage und Montage direkt am Fahrzeug sowie den begleitenden Ölwechsel. So garantieren wir eine schnelle, saubere und zuverlässige Lösung für Ihr Getriebeproblem.",
  },
  {
    id: "02",
    title: "Ersatzteile",
    description:
      "Bei uns finden Sie hochwertige Mechatronik und Getriebesteuergeräte – geprüft, aufbereitet und sofort einsatzbereit. Jedes Teil wird mit modernster Technik getestet und erfüllt höchste Qualitätsstandards. Damit sichern Sie sich langlebige, zertifizierte Komponenten für Ihr Fahrzeug.",
  },
  {
    id: "03",
    title: "Recycling & geprüfte Protokolle",
    description:
      "Defekte Mechatronik und Getriebesteuergeräte werden von uns nachhaltig recycelt und auf professionellen Prüfständen getestet. Alle Ersatzteile liefern wir mit detaillierten Prüfprotokollen, die maximale Transparenz und Zuverlässigkeit garantieren.",
  },
  {
    id: "04",
    title: "Diagnose & Beratung",
    description:
      "Wir führen präzise Diagnosen direkt am Fahrzeug durch und erkennen Fehler in Mechatronik oder Getriebesteuergerät zuverlässig. Unsere Experten beraten Sie individuell und finden die passende Lösung – ob Austausch, Programmierung oder Codierung. Klar, verständlich und ohne unnötige Kosten.",
  },
];

const gridData = [
  {
    icon: "/images/Grid/superman-ico.svg",
    title: "Schnelle & gezielte Problemlösung",
    description:
      "Ihr Fahrzeug ist defekt? Wir wissen, dass Zeit und Nerven kostbar sind. Deshalb erhalten Sie bei uns eine schnelle Diagnose, effiziente Reparatur oder den passenden Ersatz – ohne lange Wartezeiten.",
  },
  {
    icon: "/images/Grid/finance-report-ico.svg",
    title: "Stressfreier & transparenter Service",
    description:
      "Keine Überraschungen, keine versteckten Kosten. Sie wissen von Anfang an, woran Sie sind – mit klarer Kommunikation, fairen Preisen und einer einfachen Abwicklung.",
  },
  {
    icon: "/images/Grid/protection-ico.svg",
    title: "Maximale Sicherheit",
    description:
      "Ihre Sicherheit steht an erster Stelle. Mit hochwertigen Komponenten und modernster Diagnose-Technologie sorgen wir dafür, dass Ihr Fahrzeug zuverlässig und sicher auf der Straße bleibt.",
  },

  {
    icon: "/images/Grid/garant-ico.svg",
    title: "Langfristige Zuverlässigkeit",
    description:
      "Unsere Reparaturen und Ersatzteile sind auf Langlebigkeit ausgelegt. Deshalb bieten wir Ihnen eine 12-monatige Garantie auf unsere Leistungen.",
  },
  {
    icon: "/images/Grid/graph-ico.svg",
    title: "Recycling & geprüfte Protokolle",
    description:
      "Wir setzen auf Wiederaufbereitung hochwertiger Ersatzteile mit offiziellen Prüfprotokollen. So erhalten Sie geprüfte Qualität zu einem besseren Preis.",
  },
  {
    icon: "/images/Grid/cert-ico.svg",
    title: "Meisterwerkstatt der Kfz-Innung",
    description:
      "Als anerkannte Meisterwerkstatt erfüllen wir höchste Standards in Reparatur, Wartung und Qualitätssicherung – geprüft und zertifiziert.",
  },

  {
    icon: "/images/Grid/target-ico.svg",
    title: "Effizienz & Komfort",
    description:
      "Kein Stress, keine komplizierten Abläufe. Wir übernehmen alles – von der Diagnose bis zur Reparatur – damit Sie schnell wieder mobil sind.",
  },
  {
    icon: "/images/Grid/chckcar-ico.svg",
    title: "Individuelle Lösungen",
    description:
      "Jedes Fahrzeug ist anders. Deshalb bieten wir maßgeschneiderte Konzepte, die perfekt auf Ihre Bedürfnisse abgestimmt sind.",
  },
  {
    icon: "/images/Grid/global-care-ico.svg",
    title: "Nachhaltigkeit & Effizienz",
    description:
      "Umweltfreundliche Prozesse und ressourcenschonende Verfahren sind Teil unserer Unternehmensphilosophie – gut für Ihr Fahrzeug und für die Umwelt.",
  },
];

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Скролимо в верх сторінки
  }, []);

  return (
    <div>
      <title>Über Uns – HIXA – DSG Getriebe Reparatur & Wartung</title>
      <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      <Nav></Nav>
      <DoubleBlock
        leftTitle="HIXA – Ihr Partner für Qualität, Innovation und sorgenfreie Mobilität"
        rightText="Willkommen bei HIXA – Ihrem Spezialisten für Automatikgetriebe und Mechatronik. Wir wissen, dass Probleme mit dem Fahrzeug nicht nur ärgerlich, sondern oft auch eine große Belastung sind. Genau hier setzen wir an: Wir lösen Ihre Probleme schnell, effizient und nachhaltig. Unser Ziel ist es, Ihnen nicht nur erstklassige Reparaturen und Ersatzteile zu bieten, sondern auch einen stressfreien, komfortablen Service, der Sie zuverlässig auf die Straße zurückbringt."
      ></DoubleBlock>
      <ImageContainer src="/images/uber-uns-img.webp" alt="uber-uns" />
      <GridComponent items={gridData}></GridComponent>
      <ServiceBlockBerlinGrid services={services}></ServiceBlockBerlinGrid>
      <OpenMenuBlock></OpenMenuBlock>
      <VideoContainer
        videoSource="https://www.youtube-nocookie.com/embed/5g37qEjyfGY"
        title="Reparatur von Diesel-Injektoren auf dem Prüfstand – mit Garantie"
      ></VideoContainer>
      <CookiePopupButton></CookiePopupButton>
      <Footer></Footer>
    </div>
  );
};

export default Home;
